'use client';

import React, { useMemo } from 'react';
import TitleBar from '../layout/TitleBar';
import { useParams } from 'react-router-dom';
import ReportOutageActionButton from '@/components/outage/ReportOutageActionButton';
import OutageTable from '@/components/outage/OutageTable';
import { useTrks } from '@/hooks/api/useTrks';
import { useOutages } from '@/hooks/api/useOutages';
import ReportRejectActionButton from '@/components/reject/ReportRejectActionButton';
import RejectTable from '@/components/reject/RejectTable';
import { useRejects } from '@/hooks/api/useRejects';

const TrkAssetPage: React.FC = () => {


  const { trkId } = useParams();
  const { data: trksData } = useTrks();
  const { data: outagesData } = useOutages();
  const { data: rejectsData } = useRejects();
  
  const trks = useMemo(() => {
    if (!trksData) return [];
    return Array.isArray(trksData) ? trksData : Object.values(trksData);
  }, [trksData]);
  
  const trkOutages = useMemo(() => {
    if (!outagesData) return [];
    const outages = Array.isArray(outagesData) ? outagesData : Object.values(outagesData);
    return outages.filter((o: any) => o.type === 'trk' && o.assetId === trkId);
  }, [outagesData, trkId]);
  
  const trkRejects = useMemo(() => {
    if (!rejectsData) return [];
    const rejects = Array.isArray(rejectsData) ? rejectsData : Object.values(rejectsData);
    return rejects.filter((r: any) => r.type === 'trk' && r.assetId === trkId);
  }, [rejectsData, trkId]);
  
  const trk = trks.find((x: any) => x.id === parseInt(trkId!));


  const breadcrumbs = [
    { label: 'Home', href: '/app/dashboard' },
    { label: 'Trks', href: '/app/trk/assets' }, // No href for the current page
    { label: trkId ? trkId.toString() : '', href: '#' }
  ];

  const rightContent = (
    <>
      <ReportOutageActionButton type={'trk'} assetId={trkId!} />
      <ReportRejectActionButton type={'trk'} assetId={trkId!} />
    </>
  );

  return (

    <>
      <TitleBar
        breadcrumbs={breadcrumbs}
        title={"TRK: " + trk?.assetId}
        rightContent={rightContent}
      />
      <OutageTable type={'trk'} assetId={Number(trkId!)} outages={trkOutages} />
      <br />
      <RejectTable type={'trk'} assetId={Number(trkId!)} rejects={trkRejects} />
    </>

  );
};

export default TrkAssetPage;
